<template>
  <div>
    <v-tabs>
      <v-tab to="/register/documents">
        Documents
      </v-tab>
      <v-tab to="/register/assets">
        Assets
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'RegisterWrapper',
  components: {},
  data: function () {
    return {}
  }
}
</script>
<style></style>
